import { Card, CardContent, Stack, Typography } from "@mui/material";
import { formatDate, formatNumber } from "../../../../../infrastructure/utils/formatters";
import ContractorStatusBadge from "./ContractorStatusBadge";

const ProgressCard = ({
  percentComplete,
  statusTitle,
  status,
  description,
  submittedAt,
  reviewComment,
  testId,
}) => (
  <Card variant="outlined" data-testid={testId || "progress-card"}>
    <CardContent>
      <Stack spacing={1}>
        <Typography variant="subtitle1" fontWeight={700}>
          {percentComplete == null
            ? "گزارش پیشرفت"
            : `${formatNumber(percentComplete)}٪`}
        </Typography>
        <ContractorStatusBadge status={status} statusTitle={statusTitle} />
        {description ? (
          <Typography variant="body2">{description}</Typography>
        ) : null}
        {submittedAt ? (
          <Typography variant="caption" color="text.secondary">
            ثبت: {formatDate(submittedAt)}
          </Typography>
        ) : null}
        {reviewComment ? (
          <Typography variant="body2" color="text.secondary">
            بازخورد: {reviewComment}
          </Typography>
        ) : null}
      </Stack>
    </CardContent>
  </Card>
);

export default ProgressCard;
